import TeamInformation from "views/Teams/TeamInformation/TeamInformation";
import TeamTimeline from "views/Teams/TeamTimeline/TeamTimeline";
import TeamFAQ from "views/Teams/FAQ/FAQ";
import TeamTodoList from "views/Teams/TeamTodoList/TeamTodoList";
import TeamPollList from "views/Teams/TeamPoll/TeamPollList.js";
import TeamTodoListTask from "views/Teams/TeamTodoList/TeamTodoListTask/TeamTodoListTask";
import TeamWaterCooler from "views/Teams/TeamWaterCooler/TeamWaterCooler";
import TeamPost from "views/Slack/TeamPost/TeamPost";
import TeamList from "views/Slack/TeamList/TeamList";
import TeamListTask from "views/Slack/TeamListTask/TeamListTask";
import TeamDashboard from "views/Teams/TeamDashboard/TeamDashboard";
import PollListDetail from "views/Teams/TeamPoll/PollListDetail/PollListDetail.js";
import SearchedContent from "views/SearchedContent/SearchedContent";
import WellnessSurvey from "views/Survey/WellnessSurvey";
import ManageSurvey from "views/Survey/ManageSurvey";
// import Meeting from "views/Meeting/Meeting";
import MindfulnessPage from "views/MotivationalVideos/MindfulnessPage";
import InnovationVistaDashboard from "views/Teams/InnovationVistaDashboard/InnovationVistaDashboard";
import TriviaGames from "views/Trivia/TriviaGames";
import ManageTrivia from "views/Trivia/ManageTrivia";
import SingleTrivia from "views/Trivia/SingleTrivia";
import TeamCourseBuilder from "views/Teams/TeamCourseBuilder/TeamCourseBuilder";
import TeamCourseEditor from "views/Teams/TeamCourseBuilder/TeamCourseEditor";
import TeamCoursePreview from "views/Teams/TeamCourseBuilder/TeamCoursePreview";
import TeamCourseCreator from "views/Teams/TeamCourseBuilder/TeamCourseCreator";
import TeamCourseManage from "views/Teams/TeamCourseBuilder/TeamCourseManage";
import UserCourses from "views/Teams/UserCourses/UserCourses";
import UserCourseView from "views/Teams/UserCourses/UserCourseView";
import GrowthPartnerCourses from "views/Teams/GrowthPartnerCourses/GrowthPartnerCourses";
import GrowthPartnerCourseView from "views/Teams/GrowthPartnerCourses/GrowthPartnerCourseView";

const dashboardRoutes = [
  {
    path: "/teams/:teamId/timeline",
    name: "Timeline",
    icon: "Timeline",
    component: TeamTimeline,
    layout: "",
  },
  {
    path: "/teams/:teamId/innovation-vista",
    name: "Innovation Vista",
    icon: "innovation",
    component: InnovationVistaDashboard,
    layout: "",
  },
  {
    path: "/teams/:teamId/search",
    name: "",
    icon: "",
    component: SearchedContent,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/todolist",
    name: "Todo List",
    icon: "ListIcon",
    component: TeamTodoList,
    layout: "",
  },
  {
    path: "/teams/:teamId/courses",
    name: "My Courses",
    icon: "takecourse",
    component: UserCourses,
    layout: "",
  },
  {
    path: "/teams/:teamId/growth-partner-courses",
    name: "Growth Partner Courses",
    icon: "growthpartnercourse",
    component: GrowthPartnerCourses,
    layout: "",
  },
  {
    path: "/teams/:teamId/growth-partner-courses/:id/view",
    name: "Review Course",
    component: GrowthPartnerCourseView,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/courses/:id/view",
    name: "View Course",
    component: UserCourseView,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/coursebuilder",
    name: "Course Builder",
    icon: "coursebuilder",
    component: TeamCourseBuilder,
    layout: "",
    superAdminOnly: true,
  },
  {
    path: "/teams/:teamId/coursebuilder/create",
    name: "Create Course",
    component: TeamCourseCreator,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/coursebuilder/:id/edit",
    name: "Edit Course",
    component: TeamCourseEditor,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/coursebuilder/:id/preview",
    name: "Preview Course",
    component: TeamCoursePreview,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/coursebuilder/:id/manage",
    name: "Manage Course",
    component: TeamCourseManage,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/info",
    name: "Team Information",
    icon: "GroupIcon",
    component: TeamInformation,
    layout: "",
  },
  {
    path: "/teams/:teamId/dashboard",
    name: "My Dashboard",
    icon: "Dashboard",
    component: TeamDashboard,
    layout: "",
  },
  /* Removed ReTeam Conference 11/10/2024 */
  // {
  //   path: "/teams/:teamId/meeting",
  //   name: "ReTeam Conference",
  //   icon: "teamvideo",
  //   component: Meeting,
  //   layout: "",
  // },
  /* Removed ReTeam Conference 11/10/2024 */
  {
    path: "/teams/:teamId/watercooler",
    name: "Water Cooler",
    icon: "watercooler",
    component: TeamWaterCooler,
    layout: "",
  },
  {
    path: "/teams/:teamId/todo/:listId/list-task",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    component: TeamTodoListTask,
    layout: "",
  },
  {
    path: "/teams/:teamId/wellness/focus-boosters/single-trivia/:triviaId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    component: SingleTrivia,
    layout: "",
  },
  {
    path: "/teams/:teamId/post/:postId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    component: TeamPost,
    layout: "",
  },
  {
    path: "/teams/:teamId/todo-list/:listId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    component: TeamList,
    layout: "",
  },
  {
    path: "/teams/:teamId/todo-list/:listId/todo-list-item/:taskId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    exact: "true",
    component: TeamListTask,
    layout: "",
  },
  {
    path: "/teams/:teamId/poll",
    name: "Poll List",
    icon: "Poll",
    component: TeamPollList,
    layout: "",
  },
  {
    path: "/teams/:teamId/FAQ",
    name: "Team Features FAQ",
    icon: "FAQ",
    component: TeamFAQ,
    layout: "",
  },
  {
    path: "/teams/:teamId/poll/:pollId/detail",
    name: "",
    icon: "",
    component: PollListDetail,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/teams/:teamId/wellness/survey",
    name: "Survey",
    icon: "survey",
    hideFromAllSidebar: false,
    component: WellnessSurvey,
    layout: "",
  },
  {
    path: "/teams/:teamId/wellness/survey/manage",
    name: "",
    icon: "",
    hideFromAllSidebar: true,
    component: ManageSurvey,
    layout: "",
  },
  {
    path: "/teams/:teamId/training-videos",
    name: "Training Videos",
    icon: "meeting",
    component: MindfulnessPage,
    layout: "",
  },
  {
    path: "/teams/:teamId/training-documents",
    name: "Training Documents",
    icon: "doc",
    component: MindfulnessPage,
    layout: "",
  },
  {
    path: "/teams/:teamId/motivational-videos",
    name: "Mindfulness",
    icon: "wellness",
    component: MindfulnessPage,
    layout: "",
  },
  {
    path: `/teams/:teamId/wellness/focus-boosters/trivia`,
    name: "Trivia",
    icon: "trivia",
    component: TriviaGames,
    layout: "",
  },
  {
    path: "/teams/:teamId/wellness/focus-boosters/trivia/manage",
    name: "",
    icon: "",
    hideFromAllSidebar: true,
    component: ManageTrivia,
    layout: "",
  },
];

export default dashboardRoutes;
